// "No assignee" / "No collaborators" reaches the query as a null, put there by
// objectFromSelectedFilters because those options carry Id 0. The two absences differ in
// shape: on a scalar column it is the column being null, on a collection it is the collection
// being empty - no collaborator row has a null user, so eq null inside any() finds nothing. #35336

const idsIn = (field: string, values: any[]): string => {
  const ids = values.filter(v => v !== null);
  return ids.length > 0 ? `${field} in (${ids.join(",")})` : "";
};

const joinOr = (conditions: string[]): string => {
  const parts = conditions.filter(Boolean);
  return parts.length > 1 ? `(${parts.join(" or ")})` : parts[0] ?? "";
};

export const buildScalarMemberFilter = (field: string, values: any[]): string =>
  joinOr([idsIn(field, values), values.includes(null) ? `${field} eq null` : ""]);

export const buildCollectionMemberFilter = (collection: string, alias: string, field: string, values: any[]): string => {
  const ids = idsIn(field, values);

  return joinOr([
    ids ? `${collection}/any(${alias}: ${ids})` : "",
    values.includes(null) ? `not ${collection}/any()` : ""
  ]);
};
